<div class="d-flex align-items-center gap-2">
    <div class="hidden-file-input">
        <input type="file" class="form-control" id="edit-avatar" (change)="onFileSelected($event)" [accept]="accepts">
        <button type="button" class="btn btn-sm btn-primary" tabindex="-1" aria-hidden="true">
            <fa-icon [icon]="fasUpload" class="me-1"></fa-icon> Choose File
        </button>
    </div>
    <span class="hidden-file-input-name" id="edit-avatar-name">{{value()?.originalName || 'No file chosen'}}</span>
</div>